import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'
import { AlmanacFileCalendarItem } from '../calendar/types'

type Props = {
  designId: string
}

type Data = AlmanacFileCalendarItem

type Variables = { media_file_key: string }

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const replaceMedia = async (workspaceId: number, designId: string, mediaFileKey: string) => {
  const res = await sendToApi(`/w/${workspaceId}/designs/${designId}/replace_media`, {
    method: 'POST',
    body: { media_file_key: mediaFileKey },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useReplaceMedia = ({ designId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>(
    (vars) => replaceMedia(workspaceId, designId, vars.media_file_key),
    options,
  )
}
